import { IGlobalConfig } from 'api-paths-cas';

export function getGlobalConfig(): IGlobalConfig {
  return (window as any).globalConfig;
}

export async function waitForGlobalConfig(): Promise<IGlobalConfig> {
  const w = window as any;
  let waitForGlobalConfig = true;
  while (waitForGlobalConfig) {
    if (w.globalConfig) {
      // TODO: Remove once we are 100% sure all unis new and old have studentAppClient set instead of appClient
      if (!w.globalConfig.studentAppClient && w.globalConfig.appClient) {
        w.globalConfig.studentAppClient = w.globalConfig.appClient;
      }
      waitForGlobalConfig = false;
      return w.globalConfig;
    }
    console.log('Unable to get globalConfig - trying again in 50ms');
    await sleep(50);
  }
  return w.globalConfig;
}

function sleep(milliseconds: number) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}
